export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Core/Components/ClearCachesAndTempAdminConsole.vue'),
    contentData: {
        key: 'ClearCachesAndTempAdminConsole',
        visible: true
    }
};